<template>
  <div class="ranking-progress">
    <div class="ranking__progress-item" v-for="(item, index) in dataList" :key="index">
      <div class="ranking__progress-top">
        <div class="ranking__progress-label">{{ item.name }}</div>
        <div class="ranking__progress-value-wrapper">

          <span class="ranking__progress-percentage">{{ item.percentage }}</span>
          <span>%</span>
          <el-divider direction="vertical"></el-divider>
          <span class="ranking__progress-value">{{ item.value }}</span>
          <span style="margin-left:4px">{{ item.unit }}</span>
        </div>

      </div>
      <el-progress class="ranking__progress " :show-text="false" :stroke-width="strokeWidth"
        :percentage="item.percentage" stroke-linecap="butt" color=""></el-progress>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    dataList: {
      type: Array,
      default() {
        return [
          // { value: 12, name: '执法检查', percentage: 12 }
        ]
      }
    },
    strokeWidth: {
      type: Number,
      default() {
        return 10
      }


    },
  },

  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() { },
};
</script>


<style lang="scss" scoped>
.ranking-progress {
  .ranking__progress-item {
    font-size: 14px;
    color: #e6f7ff;
    line-height: 20px;

    font-weight: 400;
    margin-bottom: 8px;
  }

  .ranking__progress-top {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
  }

  .ranking__progress-label {
    width: 50%
  }


  .ranking__progress-value-wraper {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .ranking__progress-value,
  .ranking__progress-percentage {

    color: #49f0fd;
    font-weight: 400;
    padding-right: 2px;

  }

  .ranking__progress {
    ::v-deep .el-progress-bar {
      padding: 0;
      margin: 0;
    }
  }
}
</style>